import { groupBy, isEmpty, mapValues } from 'lodash';
import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetScheduleDateRangeCheckDocument,
  GetScheduleDateRangeCheckQueryVariables,
} from '../../types/api/graphql';
import { getScheduleDay } from '../utils';

export function useScheduleDateRangeCheck(
  variables: GetScheduleDateRangeCheckQueryVariables
) {
  const {
    data: scheduleDateRangeCheckData,
    loading: scheduleDateRangeCheckLoading,
  } = useCacheQuery(GetScheduleDateRangeCheckDocument, {
    variables,
    skip:
      !variables.healthProviderId || !variables.startDate || !variables.endDate,
  });

  const data = useMemo(() => {
    const appointments = mapValues(
      groupBy(
        (scheduleDateRangeCheckData?.scheduleHasAppointments ?? []).map(
          option => ({ ...option, day: getScheduleDay(option.startTime)! })
        ),
        'day'
      ),
      option => groupBy(option, 'timeOfDay')
    );

    return {
      appointments,
      hasAppointments: !isEmpty(appointments),
      hasTemplateAppointments:
        scheduleDateRangeCheckData?.scheduleHasAppliedTemplate ?? false,
    };
  }, [
    scheduleDateRangeCheckData?.scheduleHasAppointments,
    scheduleDateRangeCheckData?.scheduleHasAppliedTemplate,
  ]);

  return {
    data,
    loading: scheduleDateRangeCheckLoading,
  };
}
